(function(ns) {
	"use strict";

	var util = ns.util;

	util.component("confirm-view", {
		data: function() {
			return {
				state: ns.store.state,
				entry: ns.store.entry
			}
		},
		methods: {
			backTo: function(view) {
				this.state.reedit = true;
				this.$emit("reedit", view);
			},
			submit: function() {
				this.$emit("submit");
			},
		}
	});

})(CE);
